import { render, staticRenderFns } from "./DialogCreateSalesOrderTerm.vue?vue&type=template&id=60ae5a3d"
import script from "./DialogCreateSalesOrderTerm.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogCreateSalesOrderTerm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports